export const MANUAL_STATUS_OPTIONS = [
  { value: 'pending_shipment', label: 'Pendiente de envio' },
  { value: 'in_lab', label: 'En laboratorio' },
  { value: 'received_in_clinic', label: 'Recibido en clinica' },
  { value: 'rework', label: 'Devolucion / Re-trabajo' },
  { value: 'cancelled', label: 'Cancelado' }
];

export const STATUS_LABELS = {
  pending_shipment: 'Pendiente de envio',
  in_lab: 'En laboratorio',
  delayed: 'Retrasado',
  received_in_clinic: 'Recibido en clinica',
  rework: 'Devolucion / Re-trabajo',
  cancelled: 'Cancelado'
};

export const getCurrentDateInTimezone = (timezone) => {
  const formatter = new Intl.DateTimeFormat('en-CA', {
    timeZone: timezone,
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
  const parts = formatter.formatToParts(new Date());
  const year = parts.find((part) => part.type === 'year')?.value || '0000';
  const month = parts.find((part) => part.type === 'month')?.value || '01';
  const day = parts.find((part) => part.type === 'day')?.value || '01';
  return `${year}-${month}-${day}`;
};

export const formatLaboratoryDate = (dateValue, timezone) => {
  if (!dateValue) return '-';
  const safeDate = new Date(`${dateValue}T12:00:00Z`);
  return new Intl.DateTimeFormat('es-MX', {
    timeZone: timezone,
    year: 'numeric',
    month: 'short',
    day: '2-digit'
  }).format(safeDate);
};

export const formatLaboratoryDateTime = (dateValue, timezone) => {
  if (!dateValue) return '-';
  return new Intl.DateTimeFormat('es-MX', {
    timeZone: timezone,
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(dateValue));
};

export const getDisplayStatus = (order, timezone) => {
  const today = getCurrentDateInTimezone(timezone);
  if (
    order.status !== 'received_in_clinic' &&
    order.status !== 'cancelled' &&
    order.requestedDeliveryDate &&
    order.requestedDeliveryDate < today
  ) {
    return 'delayed';
  }
  return order.status;
};